import { useMemo } from "react";
import { useBanner } from "../../contexts";
function useTcfVendors(filter) {
    const { tcf } = useBanner();
    if (!tcf) {
        return [];
    }
    const { gvl: { vendors: gvlVendors }, model } = tcf;
    return useMemo(()=>Object.values(gvlVendors)// Only show vendor if suitable for the current filter
        .filter((param)=>{
            let { [filter === "consent" ? "purposes" : "legIntPurposes"]: usedPurposes } = param;
            return filter === "consent" ? true : usedPurposes.length > 0;
        })// We need to manually sort it again cause the `vendor-list.json#vendors` property uses numeric keys and
        // JavaScript does automatically sort it
        .sort((param, param1)=>{
            let { name: x } = param;
            let { name: y } = param1;
            return x < y ? -1 : x > y ? 1 : 0;
        }), [
        gvlVendors,
        filter,
        model
    ]);
}
export { useTcfVendors };
